export const useNavigationItems = () => {
    return [
        {
            href: 'https://jdsn.deere.com/',
            label: 'Home',
            selected: true
        },
        {
            href: 'https://jdsn.deere.com/wps/myportal/jdsn/JDSN/Applications/',
            label: 'JDSN Applications',
            target: '_blank'
        }
    ];
};
